<template>
  <main>
    <v-container class="booking-table">
      <GenericFilter />
      <v-toolbar flat class="main-header mb-6">
        <v-toolbar-title class="main-header__title">
          <h1>Jobs</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items
          v-if="permissions.includes('store_api_admin-panel_camp-types')"
          class="main-header__contents"
        >
          <v-btn
            class="my-auto mx-1 radius-12"
            color="success"
            :to="`jobs/create?category=${$route.query.category}`"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />
      <v-data-table
        :headers="headers"
        :loading="loadingDataTable"
        :items="items"
        :mobile-breakpoint="zero"
        :items-per-page="200"
        hide-default-footer
        class="table"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell name text-center">
              {{ item ? item.order : "---" }}
            </td>
            <td class="table__cell text-center">
              <read-more
                more-str="more"
                less-str="less"
                :text="item.description || '---'"
                :max-chars="20"
                class="mb-0 major-description m-b-0"
              ></read-more>
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.title : "---" }}
            </td>
            <td class="table__cell text-center">
              <v-icon large color="success" v-if="item.is_active"
                >mdi-check-circle</v-icon
              >
              <v-icon v-else large color="error">mdi-close-circle</v-icon>
            </td>
            <td class="table__cell text-center">
              <v-chip class="primary">{{ item.job_category.name }}</v-chip>
            </td>
            <td class="table__cell text-center">
              {{ item.posted_date && item.posted_date.date }}
            </td>
            <td class="table__cell text-center">
              {{ item.type }}
            </td>

            <td class="table__cell text-center">
              <router-link
                :to="{
                  name: 'editJobs',
                  params: { id: item.id },
                  query: { category: $route.query.category }
                }"
                class="hovering mr-1 edit"
                v-if="
                  permissions.includes(
                    'update_api_admin-panel_camp-types_{camp_type}'
                  )
                "
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span
                v-if="
                  permissions.includes(
                    'destroy_api_admin-panel_camp-types_{camp_type}'
                  )
                "
                @click="handleDelete(item, index)"
                class="hovering delete"
              >
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
              <span v-else>---</span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-xs-center mt-4">
        <v-pagination
          v-if="items.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="10"
          @input="handlePagination"
        ></v-pagination>
      </div>
    </v-container>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";
import { isEqual } from "lodash";

export default {
  name: "IndexJob",
  components: {
    GenericFilter: () => import("@/components/genericFilter")
  },
  data() {
    return {
      items: [],
      pagination: {},
      queries: {},
      headers: [],
      loadingDataTable: false,
      zero: 0
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
  },
  methods: {
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    handleGetJobs(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: "content/jobs", query })
        .then(res => {
          const { data, meta } = res.data;
          this.items = data;
          this.pagination = meta;
          this.loadingDataTable = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    createTableHeaders() {
      const headersList = [
        "Order",
        "Description",
        "Title",
        "Is Active",
        "Job Category",
        "posted Date",
        "Job Type",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/content/jobs`,
            id: id
          })
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch(() => {});
        }
      });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.queries = query;
        this.handleGetJobs(query);
      },
      immediate: true,
      deep: true
    },
    items: {
      handler(val) {
        const { current_page } = this.pagination;
        if (val.length === 0 && this.$route.query.page > 1) {
          this.$router.push({
            query: {
              page: current_page - 1
            }
          });
        }
        if (
          val.length > this.pagination.per_page &&
          this.$route.query.page >= 1
        ) {
          this.$router.push({
            query: {
              page: current_page + 1
            }
          });
        }
      },
      immediate: true
    }
  }
};
</script>
